import { Outlet, useParams } from "react-router";

import { PollingIntervalGroups } from "apollo/constants";
import usePolledQuery from "apollo/usePolledQuery";
import { getBreadcrumbsBackUrl } from "components/Breadcrumbs/helpers";
import useBreadcrumbs from "components/Breadcrumbs/useBreadcrumbs";
import NotFoundPage from "components/error/NotFoundPage";
import PageLoading from "components/loading/PageLoading";
import useErrorHandle from "hooks/useErrorHandle";

import { SCANS_FILTERS_ORDER_KEY } from "../components/Table/constants";
import { ScanResourcesOutletContext } from "../ScanResources/types";
import ScanRunHeader from "./components/Header";
import { GET_SCAN_RUN } from "./gql";
import { getScanRunTitle } from "./helpers";

const ScanRunLayout = () => {
  const { runId = "" } = useParams<{ runId: string }>();

  const { data, loading, error } = usePolledQuery(GET_SCAN_RUN, {
    variables: { id: runId },
    pollingGroup: PollingIntervalGroups.Lists,
    skip: !runId,
  });

  const run = data?.scanRun;

  useBreadcrumbs(
    [
      {
        title: "Resources",
        link: "/resources/iac-management",
      },
      {
        title: "Cloud scanning",
        link: getBreadcrumbsBackUrl("/resources/scans", SCANS_FILTERS_ORDER_KEY),
      },
      {
        title: run?.scan.name || "",
        link: run ? `/resources/scans/${run.scan.id}` : undefined,
      },
      {
        title: run ? getScanRunTitle(run.createdAt) : "",
      },
    ],
    [runId, run?.scan.id, run?.scan.name, run?.createdAt]
  );

  const ErrorContent = useErrorHandle(error);

  if (ErrorContent) {
    return ErrorContent;
  }

  if (loading && !run) {
    return <PageLoading />;
  }

  if (!run) {
    return <NotFoundPage />;
  }

  const outletContext: ScanResourcesOutletContext = { run };

  return (
    <>
      <ScanRunHeader run={run} />
      <Outlet context={outletContext} />
    </>
  );
};

export default ScanRunLayout;
